import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import { HintButton } from 'components/Common/Buttons';

const QuestionBlockHeader = ({ id, title, info, linkStyle, expandCollapse, isCollapsed, onExpandCollapseClick, onHideBlock, messageValues }) => {
  const intl = useIntl();
  const [showInstructions, setShowInstructions] = useState(false);

  const viewInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  const formatInstructions = () => {
    const { instructions } = info;

    if (typeof instructions === 'string') {
      return <LocalisedMessage id={ instructions } values={ messageValues } />;
    }

    if (Array.isArray(instructions) && instructions.every(instruction => typeof instruction === 'string')) {
      return (
        <div className="mt-3">
          {instructions.map(instruction => (
            <div className="mb-3">
              <LocalisedMessage id={ instruction } values={ messageValues } />
            </div>
          ))}
        </div>
      );
    }

    return instructions;
  };

  return (
    <React.Fragment>
      <legend className="question-card-header">
        { expandCollapse && <button className="show-hide-question-card" aria-expanded={ !isCollapsed } type="button" onClick={ () => onExpandCollapseClick && onExpandCollapseClick(!isCollapsed) }>
          <FontAwesomeIcon icon={ `chevron-${ isCollapsed ? 'down' : 'up' }` } />
        </button> }
        { title && <h2 className="card-group"><LocalisedMessage id={ title } /></h2>}
        { info?.instructions && <HintButton active={ showInstructions } hintType="hint" hintLabel={ intl.formatMessage({ id: info?.instructions }) } onClick={ () => viewInstructions() } /> }
        { linkStyle && <button
          className="btn-block-link btn-remove"
          type="button"
          onClick={ () => onHideBlock && onHideBlock() }
          title={ `${ intl.formatMessage({ id: 'questionnaire.remove' }) } ${ intl.formatMessage({ id: title }) }` }
          aria-label={ `${ intl.formatMessage({ id: 'questionnaire.remove' }) } ${ intl.formatMessage({ id: title }) }` }
        >
          <FontAwesomeIcon icon="trash-alt" className="fa-xs" />
        </button> }
      </legend>
      { showInstructions && <div className="info mt-1">{ formatInstructions() }</div> }
    </React.Fragment>);
};

QuestionBlockHeader.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  info: PropTypes.shape(),
  expandCollapse: PropTypes.bool,
  linkStyle: PropTypes.bool,
  isCollapsed: PropTypes.bool.isRequired,
  onExpandCollapseClick: PropTypes.func,
  onHideBlock: PropTypes.func,
  messageValues: PropTypes.shape()
};

QuestionBlockHeader.defaultProps = {
  title: '',
  info: null,
  linkStyle: false,
  expandCollapse: true,
  onExpandCollapseClick: null,
  onHideBlock: null,
  messageValues: {}
};

export default QuestionBlockHeader;
